import Select from 'react-select';
// import _debounce from 'lodash/debounce';
import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import './KPIFormModel.scss';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';

import {
  useGetKPIQuery,
  useAddKPIMutation,
  useEditKPIMutation
} from '../../../../redux/apis/KPIApi';
import { selectedKpi } from '../../../../redux/Slice/kpiSlice';
import { useIsLoggedInQuery } from '../../../../redux/apis/authApi';
import { useGetDepartmentQuery } from '../../../../redux/apis/department';
import { useGetDesignationQuery } from '../../../../redux/apis/Designation';
import { useGetEmployeeDropDownQuery } from '../../../../redux/apis/employee';

import { GLOBAL } from '../../../../utils/constant/global';
import { notification } from '../../../../utils/notification';
import { kpiFormSchema } from '../../../../utils/schemas/auth';
import { TOAST_TYPE } from '../../../../utils/constant/errorMessage';
import { BT_BUTTON_LABELS } from '../../../../utils/constant/buttons';
import { INPUT_LABEL } from '../../../../utils/constant/placeHolders';
import {
  skipRow,
  handleApiError,
  getErrorMessage,
  mergeAndRemoveDeduplicate
} from '../../../../utils/handler';

const {
  LB_OR,
  LB_NAME,
  LB_DESCRIPTION,
  LB_LB_EMPLOYEE,
  LB_DEPARTMENT_LABEL,
  LB_DESIGNATION_LABEL
} = INPUT_LABEL;
const { BTN_SAVE, BTN_CANCEL } = BT_BUTTON_LABELS;
const { TOAST_SUCCESS, TOAST_ERROR } = TOAST_TYPE;
const { DESC, ASC, EMPLOYEE_TYPE, DESIGNATION_TYPE, DEPARTMENT_TYPE } = GLOBAL;

const KPIFormModel = ({ state, setState }) => {
  const dispatch = useDispatch();

  const { refetch: leaveTypeFetch } = useGetKPIQuery({
    search: state?.search || '',
    skip: skipRow(state?.currentPage, state?.rowsPerPage),
    limit: state?.rowsPerPage,
    sort: state?.sortField,
    sortType: state.sortDirection ? DESC : ASC
  });

  const { data: dropdownData, refetch: employeeDropDownQuery } = useGetEmployeeDropDownQuery({
    skip: skipRow(state?.currentPageDropdown, state?.rowsPerPageDropdown),
    limit: state?.rowsPerPageDropdown
  });

  const { data: designationData, refetch: designationFetch } = useGetDesignationQuery({
    search: state?.search,
    limit: state?.rowsPerPageDropdownDesignation,
    skip: skipRow(state?.currentPageDesignationDropdown, state?.rowsPerPageDropdownDesignation)
  });

  const { data: departmentData, refetch: departmentFetch } = useGetDepartmentQuery({
    search: state?.search,
    limit: state?.rowsPerPageDropdownDepartment,
    skip: skipRow(state?.currentPageDepartmentDropdown, state?.rowsPerPageDropdownDepartment)
  });

  const { data: isLoggedInData } = useIsLoggedInQuery();

  const selectedKpiData = useSelector((state) => state.kpi.selectedKpiData);

  const [addKpi] = useAddKPIMutation();
  const [editKpi] = useEditKPIMutation();

  useEffect(() => {
    // Update dropdownData
    if (dropdownData && Array.isArray(dropdownData.data)) {
      const uniqueData = mergeAndRemoveDeduplicate(
        state.dropdownDataStore,
        dropdownData.data,
        '_id'
      );

      setState((prevState) => ({
        ...prevState,
        dropdownDataStore: uniqueData
      }));
    }

    // Update designationData
    if (designationData && Array.isArray(designationData.data)) {
      const uniqueData = mergeAndRemoveDeduplicate(
        state.dropdownDesignationData,
        designationData.data,
        '_id'
      );

      setState((prevState) => ({
        ...prevState,
        dropdownDesignationData: uniqueData
      }));
    }

    // Update departmentData
    if (departmentData && Array.isArray(departmentData.data)) {
      const uniqueData = mergeAndRemoveDeduplicate(
        state.dropdownDepartmentData,
        departmentData.data,
        '_id'
      );

      setState((prevState) => ({
        ...prevState,
        dropdownDepartmentData: uniqueData
      }));
    }
  }, [dropdownData, designationData, departmentData]);

  useEffect(() => {
    handleSetEditFormData();
  }, [selectedKpiData]);

  useEffect(() => {
    if (state?.isModal?.model) {
      designationFetch();
      employeeDropDownQuery();
      departmentFetch();
    }
  }, [state?.isModal?.model]);

  const {
    register,
    reset,
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(kpiFormSchema)
  });

  const createLabelObject = (data, type) => {
    const labelArray = [];
    const labelIdArray = [];

    for (let i = 0; i < data?.length; i++) {
      const element = data[i];
      if (element._id) {
        if (type === EMPLOYEE_TYPE) {
          labelArray.push({ value: element._id, label: element.name });
          labelIdArray.push(element._id);
        } else if (type === DESIGNATION_TYPE) {
          labelArray.push({ value: element._id, label: element.name });
          labelIdArray.push(element._id);
        } else {
          labelArray.push({ value: element._id, label: element?.name });
          labelIdArray.push(element._id);
        }
      } else {
        labelArray.push({ value: element, label: element });
        labelIdArray.push(element);
      }
    }
    const labelData = {
      data: labelArray,
      id: labelIdArray
    };

    return labelData;
  };

  const handleSetEditFormData = () => {
    if (selectedKpiData) {
      const employeeObj = createLabelObject(selectedKpiData?.employee, EMPLOYEE_TYPE);
      const designationObj = createLabelObject(selectedKpiData?.designation, DESIGNATION_TYPE);
      const departmentObj = createLabelObject(selectedKpiData?.department, DEPARTMENT_TYPE);

      setState((prevState) => ({
        ...prevState,
        selectDesignationData: designationObj.data,
        selectEmployeeData: employeeObj.data,
        selectDepartMentData: departmentObj.data
      }));

      setValue('name', selectedKpiData?.name || '');
      setValue('description', selectedKpiData?.description || '');
      setValue('designation', designationObj.data || '');
      setValue('employee', employeeObj.data || '');
      setValue('department', departmentObj.data || '');
    }
  };

  const handleMenuScrollToBottomDesignation = async () => {
    if (designationData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDesignationDropdown: prevState.currentPageDesignationDropdown + 1
      }));
      designationFetch();
    }
  };

  const handleMenuScrollToBottom = async () => {
    if (dropdownData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDropdown: prevState.currentPageDropdown + 1
      }));
      employeeDropDownQuery();
    }
  };

  const handleMenuScrollToBottomDepartment = async () => {
    if (departmentData.isNext) {
      setState((prevState) => ({
        ...prevState,
        currentPageDepartmentDropdown: prevState.currentPageDropdown + 1
      }));
      departmentFetch();
    }
  };

  const isEditKPI = async (data, id) => {
    try {
      // Map through specific fields and transform them if they exist
      ['employee', 'designation', 'department'].forEach((field) => {
        if (Array.isArray(data[field]) && data[field].length > 0) {
          data[field] = data[field].map((item) => item.value);
        }
      });

      const editData = {
        data,
        id
      };

      setState({ ...state, loading: true });

      // Call editKpi and handle the response
      const { data: resData, error } = await editKpi(editData);

      if (resData?.success) {
        leaveTypeFetch();
        notification(resData.statusMessage, TOAST_SUCCESS);
        handleResetState();
      } else if (error) {
        handleApiError(error);
        handleResetState();
      }
    } catch (error) {
      notification(error?.message, TOAST_ERROR);
      handleResetState();
    }
  };

  const handleResetState = () => {
    reset();
    setState({
      ...state,
      isModal: { model: false, submit: false },
      loading: false,
      modalHeader: { title: '', isEdit: false, editId: '' }
    });
  };

  const handleAddKpi = async (data) => {
    try {
      ['employee', 'designation', 'department'].forEach((field) => {
        if (Array.isArray(data[field]) && data[field].length > 0) {
          data[field] = data[field].map((item) => item.value);
        }
      });

      // Update state to indicate loading state
      setState((prevState) => ({
        ...prevState,
        loading: true
      }));

      if (data) data = { ...data, createdBy: isLoggedInData?.data?._id };

      // Perform the API call to add the KPI data (assuming addLeaveType is your API function)
      const { data: resData, error } = await addKpi(data);

      if (resData?.success) {
        leaveTypeFetch();
        notification(resData.statusMessage, TOAST_SUCCESS);
        handleResetState();
      } else if (error) {
        handleApiError(error);
        handleResetState();
      }
    } catch (error) {
      notification(error?.data?.data?.message, TOAST_ERROR);
      handleResetState();
    }
  };

  const onSubmit = (data) => {
    const leaveTypeData = {
      name: data?.name,
      description: data.description,
      designation: state.selectDesignationData,
      employee: state?.selectEmployeeData,
      department: state?.selectDepartMentData
    };

    // Update state to show modal and indicate submission in progress
    setState((prevState) => ({
      ...prevState,
      isModal: { model: true, submit: true }
    }));

    // Determine whether to edit existing data or add new data
    if (state?.editKPIData?._id) {
      // Call edit function if editing existing data
      isEditKPI(leaveTypeData, state.editKPIData._id);
    } else {
      // Call add function if adding new data
      handleAddKpi(leaveTypeData);
    }
  };

  useEffect(() => {
    register('designation');
    register('employee');
    register('department');
  }, [register]);

  const handleDialogCancel = () => {
    setState({ ...state, isModal: { model: false, submit: false } });
    dispatch(selectedKpi({}));
  };

  const updateSelection = (fieldType, selectedOptions) => {
    // Ensure selectedOptions is an array
    const newSelectedOptions = Array.isArray(selectedOptions) ? selectedOptions : [selectedOptions];
    // Create a new array to hold the updated options
    let updatedSelection = state[`select${fieldType}Data`]
      ? [...state[`select${fieldType}Data`]]
      : [];

    // Check if 'Select All' option is selected
    if (newSelectedOptions.some((option) => option.value === '-1')) {
      // If 'Select All' is selected, set the array to contain only this option
      if (
        newSelectedOptions?.length > 1 &&
        newSelectedOptions?.length <= 2 &&
        newSelectedOptions[0].value === '-1'
      ) {
        updatedSelection = newSelectedOptions.filter((selection) => selection.value !== '-1');
      } else {
        updatedSelection = [{ value: '-1', label: `Select All ${fieldType}` }];
      }
    } else {
      // Otherwise, add new selections while avoiding duplicates
      updatedSelection = [...newSelectedOptions];
    }

    setState((prevState) => ({
      ...prevState,
      [`select${fieldType}Data`]: updatedSelection
    }));
  };

  const selectMenuProps = {
    className: 'kpi-modal__select',
    classNamePrefix: 'kpi-modal-select',
    menuPortalTarget: typeof document !== 'undefined' ? document.body : null,
    menuPosition: 'fixed',
    styles: { menuPortal: (base) => ({ ...base, zIndex: 100000 }) }
  };

  return (
    <Modal
      centered
      className="kpi-modal"
      dialogClassName="kpi-modal__dialog"
      contentClassName="kpi-modal__content"
      show={state?.isModal?.model}
      onHide={() => {
        reset();
        setState({ ...state, isModal: { model: false, submit: false } });
      }}
    >
      <Modal.Header className="kpi-modal__header">
        <div className="kpi-modal__header-content">
          <span className="kpi-modal__header-icon" aria-hidden="true">
            <i className="icofont-chart-bar-graph" />
          </span>
          <div className="kpi-modal__header-copy">
            <Modal.Title className="fw-bold kpi-modal__title">
              {state?.modalHeader?.title}
            </Modal.Title>
            <p className="kpi-modal__subtitle">
              {state?.modalHeader?.isEdit
                ? 'Update this KPI and who it applies to'
                : 'Set the KPI name and who it applies to'}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close kpi-modal__close"
          aria-label="Close"
          onClick={() => {
            reset();
            setState({ ...state, isModal: { model: false, submit: false } });
          }}
        />
      </Modal.Header>
      <form className="kpi-modal__form" onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body className="kpi-modal__body">
          <div className="kpi-modal__section">
            <div className="kpi-modal__field">
              <label htmlFor="kpi-name" className="kpi-modal__label">
                {LB_NAME}
              </label>
              <input
                id="kpi-name"
                type="text"
                {...register('name')}
                className="form-control kpi-modal__input"
                placeholder={LB_NAME}
              />
              <small className="text-danger kpi-modal__error">
                {getErrorMessage('name', errors)}
              </small>
            </div>
            <div className="kpi-modal__field">
              <label htmlFor="kpi-description" className="kpi-modal__label">
                {LB_DESCRIPTION}
              </label>
              <textarea
                id="kpi-description"
                {...register('description')}
                placeholder={LB_DESCRIPTION}
                className="form-control kpi-modal__textarea"
              />
              <small className="text-danger kpi-modal__error">
                {getErrorMessage('description', errors)}
              </small>
            </div>
          </div>

          <div className="kpi-modal__section">
            <label className="kpi-modal__section-title">Applies to</label>
            <small className="text-danger kpi-modal__error">
              {getErrorMessage('designation', errors)}
            </small>
            <small className="text-danger kpi-modal__error">
              {getErrorMessage('employee', errors)}
            </small>
            <small className="text-danger kpi-modal__error">
              {getErrorMessage('department', errors)}
            </small>
            <div className="kpi-modal__field">
              <label className="kpi-modal__label">{LB_DEPARTMENT_LABEL}</label>
              <Controller
                name="department"
                control={control}
                render={({ field }) => (
                  <Select
                    {...selectMenuProps}
                    isMulti
                    menuPlacement="bottom"
                    placeholder="Select Department..."
                    options={[
                      { value: '-1', label: 'Select All Department' },
                      ...(state?.dropdownDepartmentData?.map((val) => ({
                        value: val._id,
                        label: val?.name
                      })) || [])
                    ]}
                    onMenuScrollToBottom={handleMenuScrollToBottomDepartment}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      updateSelection('DepartMent', selectedOption);
                    }}
                    value={
                      state?.selectDepartMentData?.length > 0 ? state?.selectDepartMentData : []
                    }
                    isDisabled={
                      getValues()?.employee?.length > 0 || getValues()?.designation?.length > 0
                        ? true
                        : false
                    }
                  />
                )}
              />
            </div>
            <div className="kpi-modal__or">{LB_OR}</div>
            <div className="kpi-modal__field">
              <label className="kpi-modal__label">{LB_DESIGNATION_LABEL}</label>
              <Controller
                name="designation"
                control={control}
                render={({ field }) => (
                  <Select
                    {...selectMenuProps}
                    isMulti
                    menuPlacement="top"
                    placeholder="Select Designation..."
                    options={[
                      { value: '-1', label: 'Select All Designation' },
                      ...(state?.dropdownDesignationData?.map((val) => ({
                        value: val._id,
                        label: val?.name
                      })) || [])
                    ]}
                    onMenuScrollToBottom={handleMenuScrollToBottomDesignation}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      updateSelection('Designation', selectedOption);
                    }}
                    value={
                      state?.selectDesignationData?.length > 0 ? state?.selectDesignationData : []
                    }
                    isDisabled={
                      getValues()?.department?.length > 0 || getValues()?.employee?.length > 0
                        ? true
                        : false
                    }
                  />
                )}
              />
            </div>
            <div className="kpi-modal__or">{LB_OR}</div>
            <div className="kpi-modal__field">
              <label className="kpi-modal__label">{LB_LB_EMPLOYEE}</label>
              <Controller
                name="employee"
                control={control}
                render={({ field }) => (
                  <Select
                    {...selectMenuProps}
                    isMulti
                    menuPlacement="top"
                    placeholder="Select Employee..."
                    options={[
                      { value: '-1', label: 'Select All Employees' },
                      ...(state?.dropdownDataStore?.map((val) => ({
                        value: val._id,
                        label: val?.name
                      })) || [])
                    ]}
                    onMenuScrollToBottom={handleMenuScrollToBottom}
                    onChange={(selectedOption) => {
                      field.onChange(selectedOption);
                      updateSelection('Employee', selectedOption);
                    }}
                    value={state?.selectEmployeeData?.length > 0 ? state.selectEmployeeData : []}
                    isDisabled={
                      getValues()?.department?.length > 0 || getValues()?.designation?.length > 0
                        ? true
                        : false
                    }
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="kpi-modal__footer">
          <button type="button" className="btn kpi-modal__cancel" onClick={handleDialogCancel}>
            {BTN_CANCEL}
          </button>
          <button
            type="submit"
            disabled={state?.loading || false}
            className="btn kpi-modal__submit"
          >
            {state?.loading ? (
              <div className="spinner-border spinner-border-sm" role="status"></div>
            ) : (
              <>
                <i className="icofont-check-circled" aria-hidden="true" />
                {BTN_SAVE}
              </>
            )}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default KPIFormModel;
